import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export class BibleService {
	public static bibleSave(input: any) {
		return input.bible.bibleId >= 0 ?
			Http.axios().put('/api/Bible/update', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				})
			:
			Http.axios().post('/api/Bible/add', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				});
	}

	public static bibleGetByFilter(input: any) {
		if (input.languageCodes.length === 1 && input.languageCodes[0] === 0) {
			input.languageCodes = [];
		}
		if (input.uniqueCodes.length === 1 && input.uniqueCodes[0] === 0) {
			input.uniqueCodes = [];
		}

		return Http.axios().post('/api/Bible/getbyfilter', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } }  )
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static bibleGetDetail(id: any) {
		return Http.axios().get('/api/Bible/details/' + id, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static bibleDelete(input: any) {
		return Http.axios().delete('/api/Bible/delete/' + input, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static bibleGetAll() {
		return Http.axios().get('/api/Bible/getall', { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static bibleTranslationSearch(input: any, version:any) {	
		return Http.axios().get('/api/BibleTranslation/search?searchText=' + input + '&version=' + version, {
			headers: { 'Mozilla': 'Mozilla/5.0 (Windows NT 6.1; Win64; x64; rv:47.0) Gecko/20100101 Firefox/47.3 Mozilla/5.0 (Macintosh; Intel Mac OS X x.y; rv:42.0) Gecko/20100101 Firefox/43.4.0', 'Authorization': getUserAccessToken() }
		})
		.then((res: any) => { return res; })
		.catch((e: { response: any; }) => {return e.response;}) as AxiosPromise<any>;
	}
}